import dayjs from 'dayjs';
export const getJoinedDate = (date) => {
    if (dayjs(date).isToday()) {
        return dayjs(date).format('h:mma');
    }
    return dayjs(date).format('MMM D');
};
